// This file is autogenerated from /frontend/sail-next/packages/docs/src/component-examples/Notice/Dismiss.story.tsx with go/sail-next-tailor-docs-publisher 

import React from 'react';
import { Notice, Button } from '@sail/ui';

export const Dismiss = () =>
<Notice
  type="neutral"
  onDismiss={() => console.log('hello world')}
  title="Neutral title"
  description="A short description"
  actions={<Button onPress={() => console.log('hello world')}>Button</Button>} 
/>;
